import { useQuery } from 'react-query';
import config from '@config/index';
import type { OrganizationStructure } from '@goodfynd/dashboard';

import { useOrganizationApi } from '../../hooks/api';

export default function useOrganizationStructure(organizationId: string = '') {
  const api = useOrganizationApi();
  const { data, isFetched, isFetching, isLoading, refetch } = useQuery<
    OrganizationStructure,
    unknown
  >(
    [config.queryKeys.organizationStructure, organizationId],
    () => api.getStructure(organizationId),
    {
      enabled: !!organizationId,
    }
  );

  return {
    isFetched,
    isFetching,
    isLoading,
    refetch,
    structure: data,
  };
}
